/**
 * Simple utility to handle mobile viewport height issues
 * Fixes iOS Safari/Chrome where 100vh doesn't account for dynamic UI elements
 */

export const setVhProperty = () => {
  // Calculate 1% of the current viewport height
  const vh = window.innerHeight * 0.01;
  // Set the CSS custom property --vh
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export const initViewportHeight = () => {
  // Set initial value
  setVhProperty();
  
  // Update on resize (handles address bar show/hide)
  window.addEventListener('resize', setVhProperty);
  
  // Update on orientation change
  window.addEventListener('orientationchange', () => {
    // Small delay to allow for UI changes
    setTimeout(setVhProperty, 100);
  });
};

export const cleanupViewportHeight = () => {
  window.removeEventListener('resize', setVhProperty);
  window.removeEventListener('orientationchange', setVhProperty);
};
